import { useEffect } from "react";
import { IHook } from "./usePlayEvent.types";
import { useSelector } from "react-redux";
import { IConfigurationState } from "redux/configuration/configuration.interface";
import { getUtmSource, track } from "utils";
import { MyliEventType } from "utils/types/event";

export const UsePlayEvent: IHook = ({ campaignId, isPlaying, hasWon }) => {
  const { session } = useSelector((state: IConfigurationState) => state);

  useEffect(() => {
    if (session && campaignId && isPlaying && hasWon !== null) {
      const utmSource = getUtmSource(campaignId);
      // myli_push serializes a null as the string "null": leave the key out.
      track(MyliEventType.GAME_PLAY, {
        campaignId,
        hasWon,
        ...(utmSource ? { utmSource } : {}),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignId, session, isPlaying, hasWon]);
};
